import React, { useState, useRef, Fragment } from 'react'
import Alert from '@boltui/alert'
import fetch from 'isomorphic-unfetch'
import { EmailIcon } from '@argos/icons'
import ContentLoader from 'react-content-loader'
import { gethostPath } from '../../helpers/ContentHelper'
import isValidEmail from '../../helpers/isValidEmail'

import styles from './EmailForm.scss'

const EmailForm = () => {
  const emailInputRef = useRef(null)

  const [isLoading, setLoading] = useState(false)
  const [isSuccess, setSuccess] = useState(false)
  const [isInvalidEmail, setInvalidEmail] = useState(false)

  const sendEmailService = (email) => {
    fetch(`${gethostPath()}global-api/email/address=${email}`).then((res) => {
      if (res.status === 200) setSuccess(true)
      setLoading(false)
    })
  }

  const submitEmail = (event) => {
    event.preventDefault()
    setInvalidEmail(false)
    const emailInput = emailInputRef.current
    if (isValidEmail(emailInput.value)) {
      setLoading(true)
      sendEmailService(emailInput.value)
    } else {
      emailInput.focus()
      setInvalidEmail(true)
    }
  }

  const contentLoaderProps = {
    height: 100,
    width: 100,
    speed: 1,
    primaryColor: '#f3f3f3',
    secondaryColor: '#ecebeb',
    preserveAspectRatio: 'none',
  }
  return (
    <div className='container'>
      <div className={styles['email-form']} data-test='email-offers-container'>
        <EmailIcon />
        {isLoading && (
          <ContentLoader className={'skeleton-loading-form'} {...contentLoaderProps}>
            <rect x='0' y='0' rx='0' ry='0' width='100' height='100' />
          </ContentLoader>
        )}
        {!isSuccess && (
          <Fragment>
            <label htmlFor='emailAddressInput'>
              <h4>Sign up for our latest offers</h4>
            </label>

            <form
              className={`${isInvalidEmail ? 'has-error' : ''}`}
              action='#'
              method='post'
              name='emailForm'
              data-test='email-offers-form'>
              <input
                placeholder='Email address'
                type='email'
                id='emailAddressInput'
                name='emailAddress'
                required
                ref={emailInputRef}
                data-test='email-offers-input'
              />
              <button onClick={(event) => submitEmail(event)} data-test='email-offers-button'>
                Submit
              </button>
            </form>
          </Fragment>
        )}
        {isSuccess && (
          <Fragment>
            <h4>All Done!</h4>
            <p data-test='email-offers-success'>Now just sit tight and wait for the awesome offers to hit your inbox</p>
          </Fragment>
        )}
      </div>
      {isInvalidEmail && (
        <Alert
          kind='error'
          useSentry={false}
          data-test='email-offers-error'
          isCloseable={true}
          className={styles['email-form-error']}>
          Please enter a valid email address
        </Alert>
      )}

      <small className={styles['email-form-legal']}>
        By submitting your details you consent to their use in accordance with our&nbsp;
        <a href='//www.argos.co.uk/help/privacy-policy' target='_blank'>
          Privacy Policy
        </a>
      </small>
    </div>
  )
}

export default EmailForm
